import { demoRedirecting } from './demo/bootstrap';
import { DEMO_BASE, isDemoMode } from './demo/demoMode';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { store } from './store';
import App from './App';
import { initUiVersion } from './v2/lib/uiVersion';
import { initPwa } from './utils/pwa';
import './index.css'

/* Resolve the UI version before the first render.
   The inline script in index.html already stamped `data-ui` from
   the cache so there is no flash; this runs the full resolver —
   which additionally honours the `?ui=v2` QA override — while
   still being synchronous and ahead of React. */
initUiVersion();

/* Register the service worker and start listening for
   `beforeinstallprompt`. Ahead of the first render because the
   browser fires that event early and only once — a component
   mounting later would never see it. See `src/utils/pwa.ts`. */
if (!isDemoMode) initPwa();

const container = document.getElementById('root')!;
const root = createRoot(container);
const queryClient = new QueryClient();

if (!demoRedirecting) root.render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <GoogleReCaptchaProvider
          reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY as string}
          scriptProps={{ async: true, defer: true }}
        >
          <BrowserRouter basename={isDemoMode ? DEMO_BASE : undefined}>
            <App />
          </BrowserRouter>
        </GoogleReCaptchaProvider>
      </QueryClientProvider>
    </Provider>
);
